import { render, staticRenderFns } from "./JetsonArchDialog.vue?vue&type=template&id=f96c20a2"
import script from "./JetsonArchDialog.vue?vue&type=script&lang=js"
export * from "./JetsonArchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports